// extracted by mini-css-extract-plugin
export default {"container":"Header_container__zmwVK","text":"Header_text__nrOaU","image":"Header_image__SdxR5","contactButton":"Header_contactButton__w7d42"};